module.exports = __webpack_public_path__ + "static/media/048.bc40cbf5.jpg";